<app-de-wrapper *ngIf="loading">
  <app-spinner></app-spinner>
</app-de-wrapper>
